import FilterStore from "../abstract.filter.store";
import {UserModuleServiceInterface, UserModuleStoreInterface} from "../../types";
import {
    MyAccountPasswordEditRequest,
    UserActiveRoleEditRequest,
    UserAddRequest,
    UserChangePasswordRequest,
    UserEditRequest,
    UserPrepareEditFormRequest, UserResetOtpRequest,
    UserViewRequest
} from "../../types/modules/user/request";
import {ActionEnum, ResponseTypeEnum, TranslationDomainEnum} from "../../types/enums";
import {action, makeObservable, observable, runInAction} from "mobx";
import {UserListItem} from "../../types/modules/user/modules";
import {AppStore} from "../app.store";
import {ApiResponseHandler} from "../../handler/apiResponse.handler";

export default class UserStore extends FilterStore implements UserModuleStoreInterface {
    public _items: UserListItem[] = [];

    readonly _headers: string[] = [
       'username', 'firstName', 'lastName', 'email', 'disabled'
    ]

    readonly _module: string = 'user'

    public readonly _actions: ActionEnum[] = [
        ActionEnum.VIEW, ActionEnum.EDIT
    ]

    constructor(
        private readonly appStore: AppStore,
        private readonly service: UserModuleServiceInterface
    ) {
        super();

        makeObservable(this, {
            _current: observable,
            _pageSize: observable,
            _orderFieldName: observable,
            _orderDirection: observable,
            _headers: observable,
            _items: observable,
            _loading: observable,
            setTablePaginationData: action,
            setTableFilterData: action,
        });
    }

    setTablePaginationData = ({ current, pageSize, field, order }: any) => {
        this.current = current;
        this.pageSize = pageSize;
        this.orderFieldName = field;
        this.orderDirection = order;
    }

    public list = () => {
        runInAction(() => {
            this.loading = true;
        });

        return this.service.list({
            ...this.searchFields,
            ...this.paginatorRequestParams,
            checkRoutes: this.accessCheckRequestParams
        })
            .then(({data}) => {
                runInAction(() => {
                    this.items = data.data;
                    this.total = data.totalCount;
                    this.loading = false;
                })
            });
    }

    public edit = (request: UserEditRequest) => {
        this.appStore.setLoading(true);
        return this.service.edit(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('user.message.user_edit_success', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.USER_ADMINISTRATION)
                return data;
            }).finally(() => {
                this.appStore.setLoading(false);
            });
    }

    public view = (request: UserViewRequest) => {
        return this.service.view(request)
            .then(({data}) => {
                return data;
            });
    }

    public add = (request: UserAddRequest) => {
        this.appStore.setLoading(true);
        return this.service.add(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('user.message.user_add_success', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.USER_ADMINISTRATION)
                return data;
            }).finally(() => {
                this.appStore.setLoading(false);
            });
    }

    public changePassword = (request: UserChangePasswordRequest) => {
        return this.service.changePassword(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('user.message.user_password_change', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.USER_ADMINISTRATION)
                return data;
            });
    }

    public prepareEditForm = (request: UserPrepareEditFormRequest) => {
        return this.service.prepareEditForm(request)
            .then(({data}) => {
                return data;
            });
    }

    public prepareAddForm = () => {
        return this.service.prepareAddForm()
            .then(({data}) => {
                return data;
            });
    }

    public myAccount = () => {
        return this.service.myAccount()
            .then(({data}) => {
                return data;
            });
    }

    public myAccountEdit = (request: UserEditRequest) => {
        this.appStore.setLoading(true);
        return this.service.myAccountEdit(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('user.message.user_edit_success', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.USER_ADMINISTRATION)
                return data;
            }).finally(() => {
                    this.appStore.setLoading(false);
                });
    }

    public setActiveRole = (request: UserActiveRoleEditRequest) => {
        this.appStore.setLoading(true);
        return this.service.setActiveRole(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('user.message.user_active_role_edit_success', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.USER_ADMINISTRATION)
                return data;
            }).finally(() => {
                    this.appStore.setLoading(false);
                });
    }

    public myAccountPasswordEdit = (request: MyAccountPasswordEditRequest) => {
        this.appStore.setLoading(true);
        return this.service.myAccountPasswordEdit(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('user.message.my_account_password_edit_successful', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.USER_ADMINISTRATION)
                return data;
            }).finally(() => {
                    this.appStore.setLoading(false);
                });
    }

    public resetOtp = (request: UserResetOtpRequest) => {
        this.appStore.setLoading(true);
        return this.service.resetOtp(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('user.message.otp_resetted', ResponseTypeEnum.SUCCESS, TranslationDomainEnum.USER_ADMINISTRATION)
                return data;
            }).finally(() => {
                    this.appStore.setLoading(false);
                });
    }
}